import { RootState } from '../../stories/store';
import {
    BladeNameT, FeesAndCharges, RateInfo, ReferenceData, RootModel,
} from '../navigation/types';

export const selectDefaultBlade = (
    (state: RootState): BladeNameT => state.netBank.destination as BladeNameT
);

export const selectBasePath = (
    (state: RootState): string => state.netBank.applicationRoot
);
export const selectApplicationNumber = (
    (state: RootState): string => state.netBank.applicationNumber
);

export const selectRootModel = (
    (state: RootState): RootModel => state.netBank.rootModel
);

export const selectExistingUrl = (
    (state: RootState): string => state.netBank.existingUrl
);

export const selectApplicationContent = (
    (state: RootState): string => state.netBank.applicationData.content
);

export const selectReferenceData = (
    (state: RootState): ReferenceData => state.netBank.applicationData.referenceData
);

export const selectLoanPurposeId = (
    (state: RootState): number => state.netBank.loanPurposeId
);

export const selectSubLoanPurposeId = (
    (state: RootState): number => state.netBank.subLoanPurposeId
);

export const selectLoanProductName = (
    (state: RootState): string => state.netBank.loanProductName
);

export const selectLoanTypeName = (
    (state: RootState): string => state.netBank.loanTypeName
);

export const selectTotalLoanAmount = (
    (state: RootState): number => state.netBank.totalLoanAmount
);

export const selectLoanTerm = (
    (state: RootState): number => state.netBank.loanTerm
);

export const selectStandardRate = (
    (state: RootState): RateInfo[] => state.netBank.standardRate
);

export const selectFeesAndCharges = (
    (state: RootState): FeesAndCharges[] => state.netBank.feesAndCharges
);

export const selectApplyNowClickedStatus = (
    (state: RootState): boolean => state.netBank.applyNowClicked
);
